import { render, staticRenderFns } from "./EditFaq.vue?vue&type=template&id=4f54d373"
import script from "./EditFaq.vue?vue&type=script&lang=js"
export * from "./EditFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports